export enum Age {
  FROM_18 = '18- bis 25-jährig',
  FROM_26 = '26- bis 35-jährig',
  FROM_36 = '36- bis 45-jährig',
  FROM_46 = '46- bis 55-jährig',
  FROM_56 = '56- bis 65-jährig',
  FROM_66 = '66- bis 75-jährig',
  FROM_75 = 'über 75-jährig',
  NO_DATA = 'keine Angabe'
}
